// extracted by mini-css-extract-plugin
export var heroImage = "page-module--heroImage--3079q";
export var title = "page-module--title--1UIrL";
export var lightTitle = "page-module--lightTitle--MUHs9";
export var overlay = "page-module--overlay--1yIy2";